import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/top-opportunities-by-best-fit/ranked";
const PAGE_SIZE_MAX = 100;

export const fetchTotalPipeline = createAsyncThunk(
  "totalPipeline/fetch",
  async (_, { getState }) => {
    const { filters } = getState().capture.dashboard;
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd, offset: 0, pageSize: PAGE_SIZE_MAX },
    });
    return data;
  },
);
